import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
const AccordionGroup = () => _jsx(_Fragment, {});
export default AccordionGroup;
